import { Translation } from '../interfaces/Translation';

const translation: Translation = {
	PageSize: 'Kích thước trang',
	PageOrientation: 'Loại trang',
	Format: 'Định dạng',
	DPI: 'Mật độ điểm ảnh (DPI)',
	Generate: 'Tạo',
	LanguageName: 'Tiếng Việt',
	LanguageCode: 'vi'
};

export default translation;
